export default __webpack_public_path__ + "static/media/050_brake.av1.e10f6ec6.mp4";